import { render, staticRenderFns } from "./VatDataForm.vue?vue&type=template&id=14b9d900&scoped=true&"
import script from "./VatDataForm.vue?vue&type=script&lang=js&"
export * from "./VatDataForm.vue?vue&type=script&lang=js&"
import style0 from "./VatDataForm.vue?vue&type=style&index=0&id=14b9d900&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b9d900",
  null
  
)

export default component.exports